<template>
  <div class="l-container Paymentdetails2sIndex">
    現在表示数 {{max}}
    <!-- <div>{{obj}}</div> -->

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span>
      <template v-if="this.sortColumn === 'id'">ID</template>
      <template v-if="this.sortColumn === 'contract_id'">契約情報ID</template>
      <template v-if="this.sortColumn === 'contract_type'">契約種類</template>
      <template v-if="this.sortColumn === 'contract_date'">契約日</template>
      <template v-if="this.sortColumn === 'payment_type'">支払方法種別</template>
      <template v-if="this.sortColumn === 'cancel_type'">解約種類</template>
      <template v-if="this.sortColumn === 'company_id'">会社名</template>
      <template v-if="this.sortColumn === 'office_id'">営業所</template>
      <template v-if="this.sortColumn === 'f_name'">苗字</template>
      <template v-if="this.sortColumn === 'l_name'">名前</template>
      <template v-if="this.sortColumn === 'payments_month'">支払月</template>
      <template v-if="this.sortColumn === 'plans_amount'">予定額</template>
      <template v-if="this.sortColumn === 'real_amount'">入金額</template>
      <template v-if="this.sortColumn === 'real_amount_date'">入金日</template>
      <template v-if="this.sortColumn === 'settlement_date'">決済日</template>
      <template v-if="this.sortColumn === 'unpaid_check'">入金状況</template>
      <template v-if="this.sortColumn === 'unpaid_type'">入金種類</template>
      <template v-if="this.sortColumn === 'created_at'">作成日</template>
      <template v-if="this.sortColumn === 'updated_at'">更新日</template>
       : {{sortState}}
    </span>

    <template v-if="sum && count">
      <template v-if="sum.detail && count.unpaid_check">
        <span>/ </span><span style="color: green">未納 {{unpaid_check0}} 件</span>
        <span>/ </span><span style="color: blue">受領 {{count.unpaid_check[1]}} 件 : {{sum.detail[1]}} 円</span>
        <span>/ </span><span style="color: red">滞納 {{count.unpaid_check[2]}} 件 : {{sum.detail[2]}} 円</span>
        <span>/ </span><span style="color: orange">回収不可 {{count.unpaid_check[3]}} 件 : {{sum.detail[3]}} 円</span>
      </template>
    </template>

    <div style="display: flex; flex-wrap: wrap; margin-top: 10px">
      <btn class="m-btn--column" @click.native="switchList(1)" :class="{ 'active': ListShow === 1 }">ALL</btn>
      <template v-if="user.type === 'admin' | user.type === 'owner'">
        <btn class="m-btn--column" @click.native="switchList(2)" :class="{ 'active': ListShow === 2 }">1ヶ月のみ未納</btn>
        <btn class="m-btn--column" @click.native="switchList(3)" :class="{ 'active': ListShow === 3 }">2ヶ月以上未納</btn>
      </template>
      <btn class="m-btn--column" @click.native="minou">未納者リスト</btn>
    </div>

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>

    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_id')" v-bind:class="{ 'active': contract_id }">契約情報ID</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_type')" v-bind:class="{ 'active': contract_type }">契約種類</btn>
        <btn class="m-btn--column" @click.native="switchV('contract_date')" v-bind:class="{ 'active': contract_date }">契約日</btn>
        <btn class="m-btn--column" @click.native="switchV('payment_type')" v-bind:class="{ 'active': payment_type }">支払方法種別</btn>
        <btn class="m-btn--column" @click.native="switchV('cancel_type')" v-bind:class="{ 'active': cancel_type }">解約種類</btn>
        <btn class="m-btn--column" @click.native="switchV('company_id')" v-bind:class="{ 'active': company_id }">会社名</btn>
        <btn class="m-btn--column" @click.native="switchV('office_id')" v-bind:class="{ 'active': office_id }">営業所</btn>
        <btn class="m-btn--column" @click.native="switchV('f_name')" v-bind:class="{ 'active': f_name }">苗字</btn>
        <btn class="m-btn--column" @click.native="switchV('l_name')" v-bind:class="{ 'active': l_name }">名前</btn>
        <btn class="m-btn--column" @click.native="switchV('payments_month')" v-bind:class="{ 'active': payments_month }">支払月</btn>
        <btn class="m-btn--column" @click.native="switchV('plans_amount')" v-bind:class="{ 'active': plans_amount }">予定額</btn>
        <btn class="m-btn--column" @click.native="switchV('real_amount')" v-bind:class="{ 'active': real_amount }">入金額</btn>
        <btn class="m-btn--column" @click.native="switchV('real_amount_date')" v-bind:class="{ 'active': real_amount_date }">入金日</btn>
        <btn class="m-btn--column" @click.native="switchV('settlement_date')" v-bind:class="{ 'active': settlement_date }">決済日</btn>
        <btn class="m-btn--column" @click.native="switchV('unpaid_check')" v-bind:class="{ 'active': unpaid_check }">入金状況</btn>
        <btn class="m-btn--column" @click.native="switchV('unpaid_type')" v-bind:class="{ 'active': unpaid_type }">入金種類</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
        <btn class="m-btn--column" @click.native="switchV('updated_at')" v-bind:class="{ 'active': updated_at }">更新日</btn>
      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <template v-if="ListShow === 1">
      <div class="index-box" @scroll="offset">
        <table-c>
          <tr-c slot="tr-th">
            <td-c></td-c>
            <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
            <template v-if="contract_id"><td-c><input v-model="search.contract_id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_type"><td-c><input v-model="search.contract_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.contract_date[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.contract_date[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payment_type"><td-c><input v-model="search.payment_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="cancel_type"><td-c><input v-model="search.cancel_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="company_id">
              <td-c class="select">
                <multiselect v-model="watch.company_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="companies" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="office_id">
              <td-c class="select">
                <multiselect v-model="watch.office_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="offices" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="f_name"><td-c><input v-model="search.f_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="l_name"><td-c><input v-model="search.l_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.payments_month[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.payments_month[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="plans_amount"><td-c><input v-model="search.plans_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount"><td-c><input v-model="search.real_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount_date"><td-c><input v-model="search.real_amount_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="settlement_date"><td-c><input v-model="search.settlement_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="unpaid_check">
              <td-c class="select">
                <multiselect v-model="watch.unpaid_check" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_check" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="unpaid_type">
              <td-c class="select">
                <multiselect v-model="watch.unpaid_type" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_type" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
            <template v-if="updated_at"><td-c><input v-model="search.updated_at" type="text" @keyup="searchTable()"></td-c></template>
          </tr-c>

          <tr-c slot="tr-th">
            <td-c></td-c>
            <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
            <template v-if="contract_id"><td-c><input v-model="search.not_contract_id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_type"><td-c><input v-model="search.not_contract_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.not_contract_date[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.not_contract_date[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payment_type"><td-c><input v-model="search.not_payment_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="cancel_type"><td-c><input v-model="search.not_cancel_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="company_id">
              <td-c class="select">
                <multiselect v-model="watch.not_company_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="companies" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="office_id">
              <td-c class="select">
                <multiselect v-model="watch.not_office_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="offices" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="f_name"><td-c><input v-model="search.not_f_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="l_name"><td-c><input v-model="search.not_l_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.not_payments_month[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.not_payments_month[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="plans_amount"><td-c><input v-model="search.not_plans_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount"><td-c><input v-model="search.not_real_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount_date"><td-c><input v-model="search.not_real_amount_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="settlement_date"><td-c><input v-model="search.not_settlement_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="unpaid_check">
              <td-c class="select">
                <multiselect v-model="watch.not_unpaid_check" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_check" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="unpaid_type">
              <td-c class="select">
                <multiselect v-model="watch.not_unpaid_type" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_type" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
            <template v-if="updated_at"><td-c><input v-model="search.not_updated_at" type="text" @keyup="searchTable()"></td-c></template>
          </tr-c>

          <tr-c slot="tr-th">
            <th-c @click.native='sort("index")'>index</th-c>
            <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
            <template v-if="contract_id"><th-c @click.native='sort("contract_id")'>契約情報ID</th-c></template>
            <template v-if="contract_type"><th-c @click.native='sort("contract_type")'>契約種類</th-c></template>
            <template v-if="contract_date"><th-c @click.native='sort("contract_date")'>契約日</th-c></template>
            <template v-if="contract_date"><th-c @click.native='sort("contract_date")'>〜契約日</th-c></template>
            <template v-if="payment_type"><th-c @click.native='sort("payment_type")'>支払方法種別</th-c></template>
            <template v-if="cancel_type"><th-c @click.native='sort("cancel_type")'>解約種類</th-c></template>
            <template v-if="company_id"><th-c @click.native='sort("company_id")'>会社名</th-c></template>
            <template v-if="office_id"><th-c @click.native='sort("office_id")'>営業所</th-c></template>
            <template v-if="f_name"><th-c @click.native='sort("f_name")'>苗字</th-c></template>
            <template v-if="l_name"><th-c @click.native='sort("l_name")'>名前</th-c></template>
            <template v-if="payments_month"><th-c @click.native='sort("payments_month")'>支払月</th-c></template>
            <template v-if="payments_month"><th-c @click.native='sort("payments_month")'>〜支払月</th-c></template>
            <template v-if="plans_amount"><th-c @click.native='sort("plans_amount")'>予定額 <span style="color: blue" v-if="sum">¥{{sum.plans_amount}}</span></th-c></template>
            <template v-if="real_amount"><th-c @click.native='sort("real_amount")'>入金額 <span style="color: blue" v-if="sum">¥{{sum.real_amount}}</span></th-c></template>
            <template v-if="real_amount_date"><th-c @click.native='sort("real_amount_date")'>入金日</th-c></template>
            <template v-if="settlement_date"><th-c @click.native='sort("settlement_date")'>決済日</th-c></template>
            <template v-if="unpaid_check">
              <th-c @click.native='sort("unpaid_check")'>入金状況</th-c>
            </template>
            <template v-if="unpaid_type">
              <th-c @click.native='sort("unpaid_type")'>入金種類</th-c>
            </template>
            <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
            <template v-if="updated_at"><th-c @click.native='sort("updated_at")'>更新日</th-c></template>
          </tr-c>

          <tr-c
            slot="tr-td"
            v-for="(list, index) in mapPaymentdetails2s"
            :key="list.id"
            @click.native="getPreview(list)"
            :class="{
              'duplicate': duplicate(list.contract_id, list.payments_month, list.settlement_date)
            }">

            <td-c>{{index+1}}</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="contract_id"><td-c>{{list.contract_id}}</td-c></template>
            <template v-if="contract_type"><td-c>{{list.contract.contract_type}}</td-c></template>
            <template v-if="contract_date"><td-c>{{list.contract.contract_date}}</td-c></template>
            <template v-if="contract_date"><td-c></td-c></template>
            <template v-if="payment_type"><td-c>{{list.contract.payment_type}}</td-c></template>
            <template v-if="cancel_type"><td-c>{{list.contract.cancel_type}}</td-c></template>
            <template v-if="company_id"><td-c>{{list.mapCompanyId}}</td-c></template>
            <template v-if="office_id"><td-c>{{list.mapOfficeId}}</td-c></template>
            <template v-if="f_name"><td-c>{{list.contract.f_name}}</td-c></template>
            <template v-if="l_name"><td-c>{{list.contract.l_name}}</td-c></template>
            <template v-if="payments_month"><td-c>{{list.payments_month}}</td-c></template>
            <template v-if="payments_month"><td-c></td-c></template>
            <template v-if="plans_amount"><td-c>{{list.plans_amount}}</td-c></template>
            <template v-if="real_amount"><td-c>{{list.real_amount}}</td-c></template>
            <template v-if="real_amount_date"><td-c>{{list.real_amount_date}}</td-c></template>
            <template v-if="settlement_date"><td-c>{{list.settlement_date}}</td-c></template>
            <template v-if="unpaid_check">
              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
                <div class="pointer">
                  <multiselect @select="patchPaymentdetails2(list)" v-model="list.patchUnpaid_check" :options="Unpaid_check" label="name" :show-labels="false" placeholder=""></multiselect>
                </div>
              </template>
              <template v-else>
                <td-c>{{list.mapUnpaid_check}}</td-c>
              </template>
            </template>
            <template v-if="unpaid_type">
              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
                <div class="pointer">
                  <multiselect @select="patchPaymentdetails2(list)" v-model="list.patchUnpaid_type" :options="Unpaid_type" label="name" :show-labels="false" placeholder=""></multiselect>
                </div>
              </template>
              <template v-else>
                <td-c>{{list.mapUnpaid_type}}</td-c>
              </template>
            </template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
            <template v-if="updated_at"><td-c>{{list.updated_at.substring(0, 10)}}</td-c></template>
          </tr-c>
        </table-c>
      </div>
    </template>

    <template v-if="ListShow === 2">
      <div class="index-box" @scroll="offset">
        <table-c>
          <tr-c slot="tr-th">
            <td-c></td-c>
            <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
            <template v-if="contract_id"><td-c><input v-model="search.contract_id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_type"><td-c><input v-model="search.contract_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.contract_date[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.contract_date[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payment_type"><td-c><input v-model="search.payment_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="cancel_type"><td-c><input v-model="search.cancel_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="company_id">
              <td-c class="select">
                <multiselect v-model="watch.company_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="companies" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="office_id">
              <td-c class="select">
                <multiselect v-model="watch.office_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="offices" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="f_name"><td-c><input v-model="search.f_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="l_name"><td-c><input v-model="search.l_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.payments_month[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.payments_month[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="plans_amount"><td-c><input v-model="search.plans_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount"><td-c><input v-model="search.real_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount_date"><td-c><input v-model="search.real_amount_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="settlement_date"><td-c><input v-model="search.settlement_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="unpaid_check">
              <td-c class="select">
                <multiselect v-model="watch.unpaid_check" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_check" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="unpaid_type">
              <td-c class="select">
                <multiselect v-model="watch.unpaid_type" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_type" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
            <template v-if="updated_at"><td-c><input v-model="search.updated_at" type="text" @keyup="searchTable()"></td-c></template>
          </tr-c>

          <tr-c slot="tr-th">
            <td-c></td-c>
            <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
            <template v-if="contract_id"><td-c><input v-model="search.not_contract_id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_type"><td-c><input v-model="search.not_contract_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.not_contract_date[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.not_contract_date[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payment_type"><td-c><input v-model="search.not_payment_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="cancel_type"><td-c><input v-model="search.not_cancel_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="company_id">
              <td-c class="select">
                <multiselect v-model="watch.not_company_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="companies" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="office_id">
              <td-c class="select">
                <multiselect v-model="watch.not_office_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="offices" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="f_name"><td-c><input v-model="search.not_f_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="l_name"><td-c><input v-model="search.not_l_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.not_payments_month[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.not_payments_month[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="plans_amount"><td-c><input v-model="search.not_plans_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount"><td-c><input v-model="search.not_real_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount_date"><td-c><input v-model="search.not_real_amount_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="settlement_date"><td-c><input v-model="search.not_settlement_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="unpaid_check">
              <td-c class="select">
                <multiselect v-model="watch.not_unpaid_check" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_check" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="unpaid_type">
              <td-c class="select">
                <multiselect v-model="watch.not_unpaid_type" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_type" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
            <template v-if="updated_at"><td-c><input v-model="search.not_updated_at" type="text" @keyup="searchTable()"></td-c></template>
          </tr-c>

          <tr-c slot="tr-th">
            <th-c @click.native='sort("index")'>index</th-c>
            <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
            <template v-if="contract_id"><th-c @click.native='sort("contract_id")'>契約情報ID</th-c></template>
            <template v-if="contract_type"><th-c @click.native='sort("contract_type")'>契約種類</th-c></template>
            <template v-if="contract_date"><th-c @click.native='sort("contract_date")'>契約日</th-c></template>
            <template v-if="contract_date"><th-c @click.native='sort("contract_date")'>〜契約日</th-c></template>
            <template v-if="payment_type"><th-c @click.native='sort("payment_type")'>支払方法種別</th-c></template>
            <template v-if="cancel_type"><th-c @click.native='sort("cancel_type")'>解約種類</th-c></template>
            <template v-if="company_id"><th-c @click.native='sort("company_id")'>会社名</th-c></template>
            <template v-if="office_id"><th-c @click.native='sort("office_id")'>営業所</th-c></template>
            <template v-if="f_name"><th-c @click.native='sort("f_name")'>苗字</th-c></template>
            <template v-if="l_name"><th-c @click.native='sort("l_name")'>名前</th-c></template>
            <template v-if="payments_month"><th-c @click.native='sort("payments_month")'>支払月</th-c></template>
            <template v-if="payments_month"><th-c @click.native='sort("payments_month")'>〜支払月</th-c></template>
            <template v-if="plans_amount"><th-c @click.native='sort("plans_amount")'>予定額 <span style="color: blue" v-if="sum">¥{{sum.plans_amount}}</span></th-c></template>
            <template v-if="real_amount"><th-c @click.native='sort("real_amount")'>入金額 <span style="color: blue" v-if="sum">¥{{sum.real_amount}}</span></th-c></template>
            <template v-if="real_amount_date"><th-c @click.native='sort("real_amount_date")'>入金日</th-c></template>
            <template v-if="settlement_date"><th-c @click.native='sort("settlement_date")'>決済日</th-c></template>
            <template v-if="unpaid_check">
              <th-c @click.native='sort("unpaid_check")'>入金状況</th-c>
            </template>
            <template v-if="unpaid_type">
              <th-c @click.native='sort("unpaid_type")'>入金種類</th-c>
            </template>
            <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
            <template v-if="updated_at"><th-c @click.native='sort("updated_at")'>更新日</th-c></template>
          </tr-c>

          <tr-c
            slot="tr-td"
            v-for="(list, index) in mapPaymentdetails2sDelinquent_month"
            :key="list.id"
            @click.native="getPreview(list)"
            :class="{
              'duplicate': duplicate(list.contract_id, list.payments_month, list.settlement_date)
            }">

            <td-c>{{index+1}}</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="contract_id"><td-c>{{list.contract_id}}</td-c></template>
            <template v-if="contract_type"><td-c>{{list.contract.contract_type}}</td-c></template>
            <template v-if="contract_date"><td-c>{{list.contract.contract_date}}</td-c></template>
            <template v-if="contract_date"><td-c></td-c></template>
            <template v-if="payment_type"><td-c>{{list.contract.payment_type}}</td-c></template>
            <template v-if="cancel_type"><td-c>{{list.contract.cancel_type}}</td-c></template>
            <template v-if="company_id"><td-c>{{list.mapCompanyId}}</td-c></template>
            <template v-if="office_id"><td-c>{{list.mapOfficeId}}</td-c></template>
            <template v-if="f_name"><td-c>{{list.contract.f_name}}</td-c></template>
            <template v-if="l_name"><td-c>{{list.contract.l_name}}</td-c></template>
            <template v-if="payments_month"><td-c>{{list.payments_month}}</td-c></template>
            <template v-if="payments_month"><td-c></td-c></template>
            <template v-if="plans_amount"><td-c>{{list.plans_amount}}</td-c></template>
            <template v-if="real_amount"><td-c>{{list.real_amount}}</td-c></template>
            <template v-if="real_amount_date"><td-c>{{list.real_amount_date}}</td-c></template>
            <template v-if="settlement_date"><td-c>{{list.settlement_date}}</td-c></template>
            <template v-if="unpaid_check">
              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
                <div class="pointer">
                  <multiselect @select="patchPaymentdetails2(list)" v-model="list.patchUnpaid_check" :options="Unpaid_check" label="name" :show-labels="false" placeholder=""></multiselect>
                </div>
              </template>
              <template v-else>
                <td-c>{{list.mapUnpaid_check}}</td-c>
              </template>
            </template>
            <template v-if="unpaid_type">
              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
                <div class="pointer">
                  <multiselect @select="patchPaymentdetails2(list)" v-model="list.patchUnpaid_type" :options="Unpaid_type" label="name" :show-labels="false" placeholder=""></multiselect>
                </div>
              </template>
              <template v-else>
                <td-c>{{list.mapUnpaid_type}}</td-c>
              </template>
            </template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
            <template v-if="updated_at"><td-c>{{list.updated_at.substring(0, 10)}}</td-c></template>
          </tr-c>

        </table-c>
      </div>
    </template>

    <template v-if="ListShow === 3">
      <div class="index-box" @scroll="offset">
        <table-c>
          <tr-c slot="tr-th">
            <td-c></td-c>
            <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
            <template v-if="contract_id"><td-c><input v-model="search.contract_id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_type"><td-c><input v-model="search.contract_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.contract_date[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.contract_date[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payment_type"><td-c><input v-model="search.payment_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="cancel_type"><td-c><input v-model="search.cancel_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="company_id">
              <td-c class="select">
                <multiselect v-model="watch.company_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="companies" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="office_id">
              <td-c class="select">
                <multiselect v-model="watch.office_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="offices" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="f_name"><td-c><input v-model="search.f_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="l_name"><td-c><input v-model="search.l_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.payments_month[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.payments_month[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="plans_amount"><td-c><input v-model="search.plans_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount"><td-c><input v-model="search.real_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount_date"><td-c><input v-model="search.real_amount_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="settlement_date"><td-c><input v-model="search.settlement_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="unpaid_check">
              <td-c class="select">
                <multiselect v-model="watch.unpaid_check" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_check" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="unpaid_type">
              <td-c class="select">
                <multiselect v-model="watch.unpaid_type" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_type" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
            <template v-if="updated_at"><td-c><input v-model="search.updated_at" type="text" @keyup="searchTable()"></td-c></template>
          </tr-c>

          <tr-c slot="tr-th">
            <td-c></td-c>
            <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
            <template v-if="contract_id"><td-c><input v-model="search.not_contract_id" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_type"><td-c><input v-model="search.not_contract_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.not_contract_date[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="contract_date"><td-c><input v-model="search.not_contract_date[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payment_type"><td-c><input v-model="search.not_payment_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="cancel_type"><td-c><input v-model="search.not_cancel_type" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="company_id">
              <td-c class="select">
                <multiselect v-model="watch.not_company_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="companies" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="office_id">
              <td-c class="select">
                <multiselect v-model="watch.not_office_id" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="offices" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="f_name"><td-c><input v-model="search.not_f_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="l_name"><td-c><input v-model="search.not_l_name" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.not_payments_month[0]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="payments_month"><td-c><input v-model="search.not_payments_month[1]" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="plans_amount"><td-c><input v-model="search.not_plans_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount"><td-c><input v-model="search.not_real_amount" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="real_amount_date"><td-c><input v-model="search.not_real_amount_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="settlement_date"><td-c><input v-model="search.not_settlement_date" type="text" @keyup="searchTable()" placeholder=""></td-c></template>
            <template v-if="unpaid_check">
              <td-c class="select">
                <multiselect v-model="watch.not_unpaid_check" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_check" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="unpaid_type">
              <td-c class="select">
                <multiselect v-model="watch.not_unpaid_type" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="Unpaid_type" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
              </td-c>
            </template>
            <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
            <template v-if="updated_at"><td-c><input v-model="search.not_updated_at" type="text" @keyup="searchTable()"></td-c></template>
          </tr-c>

          <tr-c slot="tr-th">
            <th-c @click.native='sort("index")'>index</th-c>
            <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
            <template v-if="contract_id"><th-c @click.native='sort("contract_id")'>契約情報ID</th-c></template>
            <template v-if="contract_type"><th-c @click.native='sort("contract_type")'>契約種類</th-c></template>
            <template v-if="contract_date"><th-c @click.native='sort("contract_date")'>契約日</th-c></template>
            <template v-if="contract_date"><th-c @click.native='sort("contract_date")'>〜契約日</th-c></template>
            <template v-if="payment_type"><th-c @click.native='sort("payment_type")'>支払方法種別</th-c></template>
            <template v-if="cancel_type"><th-c @click.native='sort("cancel_type")'>解約種類</th-c></template>
            <template v-if="company_id"><th-c @click.native='sort("company_id")'>会社名</th-c></template>
            <template v-if="office_id"><th-c @click.native='sort("office_id")'>営業所</th-c></template>
            <template v-if="f_name"><th-c @click.native='sort("f_name")'>苗字</th-c></template>
            <template v-if="l_name"><th-c @click.native='sort("l_name")'>名前</th-c></template>
            <template v-if="payments_month"><th-c @click.native='sort("payments_month")'>支払月</th-c></template>
            <template v-if="payments_month"><th-c @click.native='sort("payments_month")'>〜支払月</th-c></template>
            <template v-if="plans_amount"><th-c @click.native='sort("plans_amount")'>予定額 <span style="color: blue" v-if="sum">¥{{sum.plans_amount}}</span></th-c></template>
            <template v-if="real_amount"><th-c @click.native='sort("real_amount")'>入金額 <span style="color: blue" v-if="sum">¥{{sum.real_amount}}</span></th-c></template>
            <template v-if="real_amount_date"><th-c @click.native='sort("real_amount_date")'>入金日</th-c></template>
            <template v-if="settlement_date"><th-c @click.native='sort("settlement_date")'>決済日</th-c></template>
            <template v-if="unpaid_check">
              <th-c @click.native='sort("unpaid_check")'>入金状況</th-c>
            </template>
            <template v-if="unpaid_type">
              <th-c @click.native='sort("unpaid_type")'>入金種類</th-c>
            </template>
            <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
            <template v-if="updated_at"><th-c @click.native='sort("updated_at")'>更新日</th-c></template>
          </tr-c>

          <tr-c
            slot="tr-td"
            v-for="(list, index) in mapPaymentdetails2sDelinquent_two_month"
            :key="list.id"
            @click.native="getPreview(list)"
            :class="{
              'duplicate': duplicate(list.contract_id, list.payments_month, list.settlement_date)
            }">

            <td-c>{{index+1}}</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="contract_id"><td-c>{{list.contract_id}}</td-c></template>
            <template v-if="contract_type"><td-c>{{list.contract.contract_type}}</td-c></template>
            <template v-if="contract_date"><td-c>{{list.contract.contract_date}}</td-c></template>
            <template v-if="contract_date"><td-c></td-c></template>
            <template v-if="payment_type"><td-c>{{list.contract.payment_type}}</td-c></template>
            <template v-if="cancel_type"><td-c>{{list.contract.cancel_type}}</td-c></template>
            <template v-if="company_id"><td-c>{{list.mapCompanyId}}</td-c></template>
            <template v-if="office_id"><td-c>{{list.mapOfficeId}}</td-c></template>
            <template v-if="f_name"><td-c>{{list.contract.f_name}}</td-c></template>
            <template v-if="l_name"><td-c>{{list.contract.l_name}}</td-c></template>
            <template v-if="payments_month"><td-c>{{list.payments_month}}</td-c></template>
            <template v-if="payments_month"><td-c></td-c></template>
            <template v-if="plans_amount"><td-c>{{list.plans_amount}}</td-c></template>
            <template v-if="real_amount"><td-c>{{list.real_amount}}</td-c></template>
            <template v-if="real_amount_date"><td-c>{{list.real_amount_date}}</td-c></template>
            <template v-if="settlement_date"><td-c>{{list.settlement_date}}</td-c></template>
            <template v-if="unpaid_check">
              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
                <div class="pointer">
                  <multiselect @select="patchPaymentdetails2(list)" v-model="list.patchUnpaid_check" :options="Unpaid_check" label="name" :show-labels="false" placeholder=""></multiselect>
                </div>
              </template>
              <template v-else>
                <td-c>{{list.mapUnpaid_check}}</td-c>
              </template>
            </template>
            <template v-if="unpaid_type">
              <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'accounting'">
                <div class="pointer">
                  <multiselect @select="patchPaymentdetails2(list)" v-model="list.patchUnpaid_type" :options="Unpaid_type" label="name" :show-labels="false" placeholder=""></multiselect>
                </div>
              </template>
              <template v-else>
                <td-c>{{list.mapUnpaid_type}}</td-c>
              </template>
            </template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
            <template v-if="updated_at"><td-c>{{list.updated_at.substring(0, 10)}}</td-c></template>
          </tr-c>

        </table-c>
      </div>
    </template>

    <h1 class="m-label btn">契約情報</h1>

    <input v-model="search2.id" type="text" style="display: none">

    <div class="index-box2" @scroll="offset">
      <table>
        <tr slot="tr-td" v-for="list in contracts" :key="list.id">

          <div class="container">

            <div class="box">

              <div class="row">
                <div class="column">id</div>
                <div class="field">{{list.id}}</div>
              </div>

              <div class="row">
                <div class="column">内容変更日付</div>
                <div class="field">{{list.change_date}}</div>
              </div>

              <div class="row">
                <div class="column">解約種類</div>
                <div class="field">{{list.cancel_type}}</div>
              </div>

              <div class="row">
                <div class="column">解約日付</div>
                <div class="field">{{list.cancel_date}}</div>
              </div>

            </div>

            <div class="box">

              <div class="row">
                <div class="column">TEL</div>
                <div class="field">{{list.tel}}</div>
              </div>

              <div class="row">
                <div class="column">TEL2</div>
                <div class="field">{{list.tel2}}</div>
              </div>

              <div class="row">
                <div class="column">住所</div>
                <div class="field">{{list.address}}</div>
              </div>

              <div class="row">
                <div class="column">住所2</div>
                <div class="field">{{list.address2}}</div>
              </div>

            </div>

            <div class="box">

              <div class="row">
                <div class="column">テキスト種類</div>
                <div class="field">{{list.text_type}}</div>
              </div>

              <div class="row">
                <div class="column">支払回数</div>
                <div class="field">{{list.payments_number}}</div>
              </div>

            </div>

            <div class="box">

              <div class="row">
                <div class="column">支払期間/開始(テキスト)</div>
                <div class="field">{{list.text_payment_period_start}}</div>
              </div>

              <div class="row">
                <div class="column">支払期間/終了(テキスト)</div>
                <div class="field">{{list.text_payment_period_end}}</div>
              </div>

              <div class="row">
                <div class="column">役務期間/開始</div>
                <div class="field">{{list.service_period_start}}</div>
              </div>

              <div class="row">
                <div class="column">役務期間/終了</div>
                <div class="field">{{list.service_period_end}}</div>
              </div>

            </div>

          </div>

        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/paymentdetails2s/search?limit=' + config.LIMIT
const url2 = getAPIURL() + '/api/v1/contracts/search?limit=' + config.LIMIT
const url3 = getAPIURL() + '/api/v1/paymentdetails2s/delinquent_month?limit=' + config.LIMIT
const url4 = getAPIURL() + '/api/v1/paymentdetails2s/delinquent_two_month?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'data',
  pageNames: 'paymentdetails2s'
}
var obj2 = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url2,
  searchUrl: url2,
  pageName: 'contract',
  pageNames: 'contracts'
}
var obj3 = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url3,
  searchUrl: url3,
  pageName: 'data',
  pageNames: 'paymentdetails2sDelinquent_month'
}
var obj4 = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url4,
  searchUrl: url4,
  pageName: 'data',
  pageNames: 'paymentdetails2sDelinquent_two_month'
}
let _ = window._
export default {
  data () {
    return {
      column: false,
      sortState: '降順',
      sortColumn: 'id',

      ListShow: 1,

      id: true,
      contract_id: true,
      contract_type: false,
      contract_date: false,
      payment_type: false,
      cancel_type: false,
      company_id: true,
      office_id: true,
      payments_month: false,
      plans_amount: true,
      real_amount: true,
      real_amount_date: true,
      settlement_date: true,
      f_name: true,
      l_name: true,
      unpaid_check: true,
      unpaid_type: true,
      created_at: false,
      updated_at: false,

      search: {
        // 検索
        id: '',
        contract_id: '',
        contract_type: '',
        contract_date: [],
        payment_type: '',
        cancel_type: '',
        company_id: '',
        office_id: '',
        payments_month: [],
        plans_amount: '',
        real_amount: '',
        real_amount_date: '',
        settlement_date: '',
        f_name: '',
        l_name: '',
        unpaid_check: '',
        unpaid_type: '',
        created_at: '',
        updated_at: '',

        // 除外
        not_id: '',
        not_contract_id: '',
        not_contract_type: '',
        not_contract_date: [],
        not_payment_type: '',
        not_cancel_type: '',
        not_company_id: '',
        not_office_id: '',
        not_payments_month: [],
        not_plans_amount: '',
        not_real_amount: '',
        not_real_amount_date: '',
        not_settlement_date: '',
        not_f_name: '',
        not_l_name: '',
        not_unpaid_check: '',
        not_unpaid_type: '',
        not_created_at: '',
        not_updated_at: ''
      },

      search2: {
        id: ''
      },

      watch: {
        company_id: [],
        office_id: [],
        unpaid_check: [],
        unpaid_type: [],

        not_company_id: [],
        not_office_id: [],
        not_unpaid_check: [],
        not_unpaid_type: []
      },

      Unpaid_check: [
        { name: '==', value: 0 },
        { name: '受領', value: 1 },
        { name: '滞納', value: 2 },
        { name: '回収不可', value: 3 },
        { name: '違約金受領', value: 4 }
      ],

      Unpaid_type: [
        { name: '==', value: 0 },
        { name: 'ファクター', value: 1 },
        { name: 'ゆうちょ', value: 2 },
        { name: 'コンビニ', value: 3 },
        { name: '現金', value: 4 },
        { name: 'Coiney', value: 5 }
      ]
    }
  },

  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    sum () {
      return this.$store.getters.sum
    },

    count () {
      return this.$store.getters.count
    },

    total () {
      const unpaid_check0 = this.$store.getters.count.unpaid_check[0]
      const unpaid_check1 = this.$store.getters.count.unpaid_check[1]
      const unpaid_check2 = this.$store.getters.count.unpaid_check[2]
      const unpaid_check3 = this.$store.getters.count.unpaid_check[3]
      return unpaid_check0 + unpaid_check1 + unpaid_check2 + unpaid_check3
    },

    unpaid_check0 () {
      const unpaid_check0 = this.$store.getters.count.unpaid_check[0]
      return unpaid_check0
    },

    user () {
      return this.$store.getters.user
    },

    companies () {
      return this.$store.getters.companies
    },

    offices () {
      return this.$store.getters.offices
    },

    contracts () {
      return this.$store.getters.contracts
    },

    paymentdetails2s () {
      return this.$store.getters.paymentdetails2s
    },

    paymentdetails2sDelinquent_month () {
      return this.$store.getters.paymentdetails2sDelinquent_month
    },

    paymentdetails2sDelinquent_two_month () {
      return this.$store.getters.paymentdetails2sDelinquent_two_month
    },

    contractIds () {
      return this.paymentdetails2s.map(paymentdetails2 => paymentdetails2.contract_id)
    },

    orderedPaymentdetails2s () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.paymentdetails2s, this.sortColumn, 'desc')
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.paymentdetails2s, this.sortColumn)
      }
    },

    orderedPaymentdetails2sDelinquent_month () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.paymentdetails2sDelinquent_month, this.sortColumn, 'desc')
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.paymentdetails2sDelinquent_month, this.sortColumn)
      }
    },

    orderedPaymentdetails2sDelinquent_two_month () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.paymentdetails2sDelinquent_two_month, this.sortColumn, 'desc')
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.paymentdetails2sDelinquent_two_month, this.sortColumn)
      }
    },

    mapPaymentdetails2s () {
      let self = this
      return self.orderedPaymentdetails2s.map(paymentdetail2 => {
        paymentdetail2.mapCompanyId = self.calcArry(paymentdetail2.contract.company_id, 'companies')
        paymentdetail2.mapOfficeId = self.calcArry(paymentdetail2.contract.office_id, 'offices')
        paymentdetail2.mapUnpaid_check = self.calcSelect(paymentdetail2.unpaid_check, 'Unpaid_check')
        paymentdetail2.mapUnpaid_type = self.calcSelect(paymentdetail2.unpaid_type, 'Unpaid_type')
        paymentdetail2.patchUnpaid_check = self.calcUnpaid_check(paymentdetail2.unpaid_check)
        paymentdetail2.patchUnpaid_type = self.calcUnpaid_type(paymentdetail2.unpaid_type)
        return paymentdetail2
      })
    },

    mapPaymentdetails2sDelinquent_month () {
      let self = this
      return self.orderedPaymentdetails2sDelinquent_month.map(paymentdetail2 => {
        paymentdetail2.mapCompanyId = self.calcArry(paymentdetail2.contract.company_id, 'companies')
        paymentdetail2.mapOfficeId = self.calcArry(paymentdetail2.contract.office_id, 'offices')
        paymentdetail2.mapUnpaid_check = self.calcSelect(paymentdetail2.unpaid_check, 'Unpaid_check')
        paymentdetail2.mapUnpaid_type = self.calcSelect(paymentdetail2.unpaid_type, 'Unpaid_type')
        paymentdetail2.patchUnpaid_check = self.calcUnpaid_check(paymentdetail2.unpaid_check)
        paymentdetail2.patchUnpaid_type = self.calcUnpaid_type(paymentdetail2.unpaid_type)
        return paymentdetail2
      })
    },

    mapPaymentdetails2sDelinquent_two_month () {
      let self = this
      return self.orderedPaymentdetails2sDelinquent_two_month.map(paymentdetail2 => {
        paymentdetail2.mapCompanyId = self.calcArry(paymentdetail2.contract.company_id, 'companies')
        paymentdetail2.mapOfficeId = self.calcArry(paymentdetail2.contract.office_id, 'offices')
        paymentdetail2.mapUnpaid_check = self.calcSelect(paymentdetail2.unpaid_check, 'Unpaid_check')
        paymentdetail2.mapUnpaid_type = self.calcSelect(paymentdetail2.unpaid_type, 'Unpaid_type')
        paymentdetail2.patchUnpaid_check = self.calcUnpaid_check(paymentdetail2.unpaid_check)
        paymentdetail2.patchUnpaid_type = self.calcUnpaid_type(paymentdetail2.unpaid_type)
        return paymentdetail2
      })
    }
  },

  watch: {
    'watch.company_id': function (now, old) {
      if (now) {
        this.search.company_id = ''
        for (let i = 0; i < now.length; i++) {
          if (now[i].id !== 0) {
            this.search.company_id += now[i].id + ' '
          } else {
            this.search.company_id += '== '
          }
        }
        this.searchTable()
      }
    },

    'watch.not_company_id': function (now, old) {
      if (now) {
        this.search.not_company_id = ''
        for (let i = 0; i < now.length; i++) {
          if (now[i].id !== 0) {
            this.search.not_company_id += now[i].id + ' '
          } else {
            this.search.not_company_id += '== '
          }
        }
        this.searchTable()
      }
    },

    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = ''
        for (let i = 0; i < now.length; i++) {
          if (now[i].id !== 0) {
            this.search.office_id += now[i].id + ' '
          } else {
            this.search.office_id += '== '
          }
        }
        this.searchTable()
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = ''
        for (let i = 0; i < now.length; i++) {
          if (now[i].id !== 0) {
            this.search.not_office_id += now[i].id + ' '
          } else {
            this.search.not_office_id += '== '
          }
        }
        this.searchTable()
      }
    },

    'watch.unpaid_check': function (now, old) {
      if (now) {
        this.search.unpaid_check = ''
        for (let i = 0; i < now.length; i++) {
          if (now[i].value !== 0) {
            this.search.unpaid_check += now[i].value + ' '
          } else {
            this.search.unpaid_check += '== '
          }
        }
        this.searchTable()
      }
    },

    'watch.not_unpaid_check': function (now, old) {
      if (now) {
        this.search.not_unpaid_check = ''
        for (let i = 0; i < now.length; i++) {
          if (now[i].value !== 0) {
            this.search.not_unpaid_check += now[i].value + ' '
          } else {
            this.search.not_unpaid_check += '== '
          }
        }
        this.searchTable()
      }
    },

    'watch.unpaid_type': function (now, old) {
      if (now) {
        this.search.unpaid_type = ''
        for (let i = 0; i < now.length; i++) {
          if (now[i].value !== 0) {
            this.search.unpaid_type += now[i].value + ' '
          } else {
            this.search.unpaid_type += '== '
          }
        }
        this.searchTable()
      }
    },

    'watch.not_unpaid_type': function (now, old) {
      if (now) {
        this.search.not_unpaid_type = ''
        for (let i = 0; i < now.length; i++) {
          if (now[i].value !== 0) {
            this.search.not_unpaid_type += now[i].value + ' '
          } else {
            this.search.not_unpaid_type += '== '
          }
        }
        this.searchTable()
      }
    }
  },

  methods: {
    minou () {
      const lastDayOfLastMonth = moment().date(0).endOf('month').format('YYYY/MM/DD HH:mm:ss')
      // console.log(moment().date(0).endOf('month').format('YYYY/MM/DD HH:mm:ss'))

      this.search.not_cancel_type = 'cxl 中途 強制'
      this.search.payments_month[1] = (lastDayOfLastMonth.substr(0, 4) + '-' + lastDayOfLastMonth.substr(5, 2) + '-' + lastDayOfLastMonth.substr(8, 2))
      this.search.settlement_date = '=='
      this.searchTable()
    },

    duplicate (contract_id, payments_month, real_amount_date) {
      let count = this.contractIds.filter(item => {
        return item === contract_id
      }).length
      return count > 1 & new Date() > moment(new Date(payments_month)).add(1, 'months') & real_amount_date === null
    },

    calcArry (val, text) {
      if (this[text].length > 0) {
        return this[text].filter(item => {
          return val === item.id
        })[0].name
      } else {
        return
      }
    },

    calcSelect (val, text) {
      if (this[text].length > 0) {
        return this[text].filter(item => {
          return val === item.value
        })[0].name
      } else {
        return
      }
    },

    calcUnpaid_check (unpaid_check) {
      if (toString.call(unpaid_check) === '[object Number]') {
        let obj = this.Unpaid_check[unpaid_check]
        return obj
      } else if (toString.call(unpaid_check) === '[object Object]') {
        return unpaid_check
      }
    },

    calcUnpaid_type (unpaid_type) {
      if (toString.call(unpaid_type) === '[object Number]') {
        let obj = this.Unpaid_type[unpaid_type]
        return obj
      } else if (toString.call(unpaid_type) === '[object Object]') {
        return unpaid_type
      }
    },

    getPreview (list) {
      this.search2.id = list.contract_id
      this.searchTable2()
    },

    switchV (col) {
      this[col] = !this[col]
    },

    switchList (col) {
      this.ListShow = col
      console.log(`ListShow: ${col}`)
    },

    select (selectedOption, id) {
      console.log(selectedOption)
    },

    reset () {
      this.id = false
      this.contract_id = false
      this.contract_type = false
      this.contract_date = false
      this.contract_date_end = false
      this.payment_type = false
      this.cancel_type = false
      this.company_id = false
      this.office_id = false
      this.payments_month = false
      this.payments_month_end = false
      this.plans_amount = false
      this.real_amount = false
      this.real_amount_date = false
      this.settlement_date = false
      this.f_name = false
      this.l_name = false
      this.unpaid_check = false
      this.unpaid_type = false
      this.created_at = false
      this.updated_at = false
    },

    all () {
      this.id = true
      this.contract_id = true
      this.contract_type = true
      this.contract_date = true
      this.contract_date_end = true
      this.payment_type = true
      this.cancel_type = true
      this.company_id = true
      this.office_id = true
      this.payments_month = true
      this.payments_month_end = true
      this.plans_amount = true
      this.real_amount = true
      this.real_amount_date = true
      this.settlement_date = true
      this.f_name = true
      this.l_name = true
      this.unpaid_check = true
      this.unpaid_type = true
      this.created_at = true
      this.updated_at = true
    },

    linkPaymentdetail2 (paymentdetail2) {
      this.$router.push({name: 'paymentdetail2', params: { id: paymentdetail2.id }})
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      if (this.ListShow === 1) {
        this.$store.dispatch('SCROLL', {
          this: this,
          e: e,
          obj: obj
        })
      } else if (this.ListShow === 2) {
        this.$store.dispatch('SCROLL', {
          this: this,
          e: e,
          obj: obj3
        })
      } else if (this.ListShow === 3) {
        this.$store.dispatch('SCROLL', {
          this: this,
          e: e,
          obj: obj4
        })
      }
    },

    searchTable (e) {
      if (this.ListShow === 1) {
        this.$store.dispatch('SEARCH', {
          this: this,
          e: e,
          obj: obj
        })
      } else if (this.ListShow === 2) {
        this.$store.dispatch('SEARCH', {
          this: this,
          e: e,
          obj: obj3
        })
      } else if (this.ListShow === 3) {
        this.$store.dispatch('SEARCH', {
          this: this,
          e: e,
          obj: obj4
        })
      }
    },

    searchTable2 (e) {
      this.$store.dispatch('SEARCH2', {
        this: this,
        e: e,
        obj: obj2
      })
    },

    patchPaymentdetails2 (list) {
      console.log(list)
      setTimeout(() => {
        this.$store.dispatch('patchPaymentdetails2', {
          list: list,
          obj: obj
        })
      }, 0) // action.js 渡って、data.list.unpaid_check.value が変更前の値に置き換わってしまう謎の挙動を改善する呪文
    },

    resetSearch () {
      this.search.id = ''
      this.search.contract_id = ''
      this.search.contract_type = ''
      this.search.contract_date = ''
      this.search.payment_type = ''
      this.search.cancel_type = ''
      this.watch.company_id = []
      this.watch.office_id = []
      this.search.f_name = ''
      this.search.l_name = ''
      this.search.payments_month = ''
      this.search.plans_amount = ''
      this.search.real_amount = ''
      this.search.real_amount_date = ''
      this.search.settlement_date = ''
      this.watch.unpaid_check = []
      this.watch.unpaid_type = []
      this.search.created_at = ''
      this.search.updated_at = ''

      this.search.not_id = ''
      this.search.not_contract_id = ''
      this.search.not_contract_type = ''
      this.search.not_contract_date = ''
      this.search.not_payment_type = ''
      this.search.not_cancel_type = ''
      this.watch.not_company_id = []
      this.watch.not_office_id = []
      this.search.not_f_name = ''
      this.search.not_l_name = ''
      this.search.not_payments_month = ''
      this.search.not_plans_amount = ''
      this.search.not_real_amount = ''
      this.search.not_real_amount_date = ''
      this.search.not_settlement_date = ''
      this.watch.not_unpaid_check = []
      this.watch.not_unpaid_type = []
      this.search.not_created_at = ''
      this.search.not_updated_at = ''

      this.searchTable()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('Paymentdetails2sSearch')
      let obj = JSON.parse(getjson)

      vm.id = obj['column_id']
      vm.contract_id = obj['column_contract_id']
      vm.contract_type = obj['column_contract_type']
      vm.contract_date = obj['column_contract_date']
      vm.payment_type = obj['column_payment_type']
      vm.cancel_type = obj['column_cancel_type']
      vm.company_id = obj['column_company_id']
      vm.office_id = obj['column_office_id']
      vm.payments_month = obj['column_payments_month']
      vm.plans_amount = obj['column_plans_amount']
      vm.real_amount = obj['column_real_amount']
      vm.real_amount_date = obj['column_real_amount_date']
      vm.settlement_date = obj['column_settlement_date']
      vm.f_name = obj['column_f_name']
      vm.l_name = obj['column_l_name']
      vm.unpaid_check = obj['column_unpaid_check']
      vm.unpaid_type = obj['column_unpaid_type']
      vm.created_at = obj['column_created_at']
      vm.updated_at = obj['column_updated_at']

      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {
      column_id: this.id,
      column_contract_id: this.contract_id,
      column_contract_type: this.contract_type,
      column_contract_date: this.contract_date,
      column_payment_type: this.payment_type,
      column_cancel_type: this.cancel_type,
      column_company_id: this.company_id,
      column_office_id: this.office_id,
      column_payments_month: this.payments_month,
      column_plans_amount: this.plans_amount,
      column_real_amount: this.real_amount,
      column_real_amount_date: this.real_amount_date,
      column_settlement_date: this.settlement_date,
      column_f_name: this.f_name,
      column_l_name: this.l_name,
      column_unpaid_check: this.unpaid_check,
      column_unpaid_type: this.unpaid_type,
      column_created_at: this.created_at,
      column_updated_at: this.updated_at
    }

    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('Paymentdetails2sSearch', setjson)
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.clicked {
  font-weight: bold;
}
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.tr {
  border-bottom: solid 1px #ccc;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
  border-bottom: none !important;
  min-width: 110px;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(70vh - 147px);
  overflow: scroll;
  margin-top: 10px;
}
.index-box2 {
  height: calc(30vh - 140px);
  overflow: scroll;
  margin-top: 10px;
  table {
    width:100%;
    tr {
      .container {
        display: flex;
        .box {
          width: 25%;
          border-top: solid 1px #ccc;
          .row {
            display: flex;
            width: auto;
            border-left: solid 1px #ccc;
            border-bottom: solid 1px #ccc;
            .column {
              background: #fbfbfb;
              border-right: solid 1px #ccc;
              width: 50%;
              padding: 1px;
            }
            .field {
              width: 50%;
              border-right: solid 1px #ccc;
              padding: 1px;
            }
          }
        }
      }
    }
  }
}

.duplicate {
  background: #41b883;
  color: #fff;
}
.pointer {
  cursor: pointer;
  display: table-cell;
  border-right: solid 1px #ccc;
}
</style>

<style lang="scss">
.Paymentdetails2sIndex {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tag {
    margin: 1px;
    font-size: 10px;
  }
  .multiselect__tag-icon {
    line-height: 18px;
    &:after {
      font-size: 10px;
    }
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 26px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    /* margin: 3px 1px 1px 1px; */
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// Paymentdetails2sIndex.vue?8c75fc8a